<template>
    <component :is="tag" v-bind="linkProps" @click="handleClick" class="badge text-white flex items-center justify-center truncate"
          :style="computedStyle"
          :class="['bg-' + color, sizeString ? 'badge-' + sizeString : '', roundedString, {absolute: absolute, 'px-8': spaced}]">
        <slot/>
    </component>
</template>

<script>
import Positionable from "../../mixins/Positionable";
    import Sizeable from "../../mixins/Sizeable";
    import Roundable from "../../mixins/Roundable";
    import Linkable from "../../mixins/Linkable";

    export default {
        name: "Badge",

        mixins: [Positionable, Sizeable, Roundable, Linkable],

        props: {
            color: {
                default: 'primary'
            },

            absolute: {
                type: Boolean,
                default: false,
            },

            // Whether a padding shall be added
            spaced: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            computedStyle() {
                let style = {
                    bottom: 'auto',
                    left: 'auto',
                    right: 'auto',
                    top: 'auto',
                };
                if (this.top) {
                    style.bottom = 'calc(100% - 12px)';
                }
                if (this.right) {
                    style.left = 'calc(100% - 12px)';
                }
                if (this.left) {
                    style.right = 'calc(100% - 12px)';
                }
                if (this.bottom) {
                    style.top = 'calc(100% - 12px)';
                }

                return style;
            },

            tag() {
                if (this.absoluteTo) {
                    return 'a';
                }
                if (this.relativeTo) {
                    return resolveComponent('NuxtLink');
                }

                return 'span';
            },
        }
    }
</script>

<style>
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.badge {
  height: 16px;
  min-width: 16px;
  font-size: 11.2px;
  color: #5e6b6b;
  background-color: #bebebe;
}
.badge.badge-xs {
  height: 6px;
  min-width: 6px;
  font-size: 4.2px;
}
.badge.badge-sm {
  height: 12px;
  min-width: 12px;
  font-size: 8.4px;
}
.badge.badge-lg {
  height: 20px;
  min-width: 20px;
  font-size: 14px;
}
</style>